export const LINK_LI_ACCOUNT = "link_linkedin_account";
export const DISCONNECT_COMMENTIFY_ACCOUNT = "disconnect_commentify_account";
export const GET_PROFILE_DETAILS = "get_profile_details";
